import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { useStrings } from '../../i18n';
import { useCart } from '../../context/CartContext';
import { sanitizeCart } from '../../utils/cartUtils';

export default function NavbarLinks({
  activeSection,
  handleScroll,
  linkClass,
  isMobile = false,
  onClose = () => {},
}) {
  const strings = useStrings();
  const { cartItems } = useCart();

  // Derived purely from CartContext — no separate state, no API calls.
  // sanitizeCart strips corrupt/invalid items so the count is always accurate.
  const cartCount = useMemo(
    () => sanitizeCart(cartItems).reduce((sum, item) => sum + (item.quantity || 0), 0),
    [cartItems]
  );
  const displayCount = cartCount > 99 ? '99+' : cartCount;

  const handleClick = (section) => {
    handleScroll(section);
    if (isMobile) onClose();
  };

  const mobileClass = isMobile ? 'block w-full text-left py-3 px-4' : '';

  return (
    <div className={isMobile ? 'flex flex-col space-y-2' : 'flex space-x-4 items-center'}>
      <button
        onClick={() => handleClick('hero')}
        className={`${linkClass('hero')} ${mobileClass}`}
      >
        {strings.nav.home}
      </button>
      <button
        onClick={() => handleClick('collection')}
        className={`${linkClass('collection')} ${mobileClass}`}
      >
        {strings.nav.shop}
      </button>
      <button
        onClick={() => handleClick('about')}
        className={`${linkClass('about')} ${mobileClass}`}
      >
        {strings.nav.about}
      </button>

      {/* Cart — active state is derived from location, not from a click handler */}
      <div className="relative inline-flex">
        <NavLink
          to="/cart"
          className={`${linkClass('cart')} ${mobileClass}`}
          onClick={() => { if (isMobile) onClose(); }}
        >
          {strings.nav.cart}
        </NavLink>

        {/* Cart count badge — hidden when cart is empty */}
        {cartCount > 0 && (
          <span className="absolute -top-2 -right-2 bg-secondary text-surface text-xs font-semibold min-w-[1.25rem] h-5 flex items-center justify-center px-1 rounded-full pointer-events-none">
            {displayCount}
          </span>
        )}
      </div>
    </div>
  );
}
